import { HeaderViewType, IDesktopHeaderSectionData } from "@pageBuilder/typings";
import { MeshSectionRendererBase } from "../mesh-section-renderer-base";

export class HeaderDesktopSectionRenderer extends MeshSectionRendererBase {

    protected createNewSection(): HTMLElement {
        const element = document.createElement("section");
        element.setAttribute("data-section", "headerDesktopSection");
        const content = this.createContentElement();

        const background = document.createElement("div");
        background.classList.add("background");

        element.append(background, content);

        return element;
    }

    protected override renderInternal(element: HTMLElement, data: IDesktopHeaderSectionData): HTMLElement {
        const headerElement = super.renderInternal(element, data);

        this.renderSectionVisibility(headerElement, data);
        this.renderViewType(element, data.viewType);

        this.renderScreen(headerElement, data);
        return headerElement;
    }

    protected cleanupInternal(element: HTMLElement): void {
        this.cleanupScreenMesh(element);
    }

    private renderViewType(element: HTMLElement, viewType?: HeaderViewType): void {
        element.classList.toggle("view-static", viewType === "static" || viewType === "all");
        element.classList.toggle("view-on-scroll", viewType === "scroll" || viewType === "all");
    }

}
